import type { Candidate } from '../types';
import { mockCandidate } from './mockCandidate';

export const candidateMock: Candidate = mockCandidate();
